import { render } from "./SetupYubikeyPage.vue?vue&type=template&id=21371f61&scoped=true"
import script from "./SetupYubikeyPage.vue?vue&type=script&lang=js"
export * from "./SetupYubikeyPage.vue?vue&type=script&lang=js"

import "./SetupYubikeyPage.vue?vue&type=style&index=0&id=21371f61&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21371f61"]])

export default __exports__